let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aqPSc")).then(() => parcelRequire('5KA11'));